import { TENANT_IDS } from "./tenantIds";

const dgeErp = {
    id: TENANT_IDS.DGE_ERP,

    branding: {
        appName:        'DGES ERP',
        companyName:    'Colombo Dockyard Engineering',
        companyShort:   'DGES',
        copyright:      '© 2026 Colombo Dockyard Engineering — Dockyard Software',
        tagline:        'Enterprise ERP',
        logoUrl: '/dgeslogo.png',
        logoOnLightChip: true,
        loginTitle:     'Sign In to DGE-ERP',
        loginSubtitle:  'Sign in to access DGE-ERP',
        welcomeMessage: "Here's what's happening across DGE systems today.",
        securityBadges: ['🔒 Secure Login', '🛡️ 2FA Enabled', '🔐 SSL Protected'],
    },

    theme: {
        primary: {
            50:  '#fffbeb', 100: '#fef3c7', 200: '#fde68a', 300: '#fcd34d',
            400: '#fbbf24', 500: '#f59e0b', 600: '#d97706', 700: '#b45309',
            800: '#92400e', 900: '#78350f',
        },
        chartColors: [
            '#d97706', '#2a78d6', '#1baf7a', '#4a3aa7',
            '#e87ba4', '#0e7490', '#a16207', '#64748b',
        ],

        // Employee card / modal accent
        accent: {
            solid: '#d6264b',
            dark: '#a81a39',
            tint: '#fdf2f5',
            ring: '#f7c3ce',
        }
    },
}

export default dgeErp;